/**
 * Service Schema Definition
 * This schema defines the structure for all medical services offered by facilities
 */

export const ServiceSchema = {
  serviceId: '', // Unique identifier (e.g., UUID)
  serviceName: '', // e.g., "Doctor Consultation"
  category: '', // e.g., "Consultations", "Specialist Services"
  specialty: null, // e.g., "Gastroenterology", null if general
  subCategory: null, // Optional further grouping (e.g., "Endoscopy")
  description: '', // Detailed info for staff/patient (optional)
  cost: 0, // Base price (number, in ZAR or your currency)
  durationMinutes: 0, // Default slot duration (number, in minutes)
  deliveryModes: [], // Allowed options: In-Person, Virtual, Home Visit, etc.
  requiredPractitionerType: '', // GP, Specialist, Nurse, Allied Health, etc.
  status: 'active', // "active", "inactive", "archived"
  billingCode: '', // ICD-10, CPT, internal code (optional)
  billableItems: [], // List of consumables/add-ons (optional)
  facilityTypes: [], // Clinic, Hospital, Mobile Unit, etc. (optional)
  customisable: true, // Can this service be edited/cloned by user?
  tags: [], // Array of tags for filtering/search (optional)
  displayOrder: 0 // Integer for UI ordering
}

/**
 * Billable Item Schema
 */
export const BillableItemSchema = {
  itemId: '', // Unique identifier
  itemName: '', // Name of the item
  itemType: 'consumable' // service, consumable, medication, etc.
}

/**
 * Delivery Modes Enum
 */
export const DeliveryModes = {
  IN_PERSON: 'In-Person',
  VIRTUAL: 'Virtual',
  HOME_VISIT: 'Home Visit',
  WORKPLACE: 'Workplace',
  MOBILE_UNIT: 'Mobile Unit'
}

/**
 * Practitioner Types Enum
 */
export const PractitionerTypes = {
  GP: 'General Practitioner',
  SPECIALIST: 'Specialist',
  NURSE: 'Nurse',
  ALLIED_HEALTH: 'Allied Health Professional',
  PHARMACIST: 'Pharmacist',
  TECHNICIAN: 'Medical Technician'
}

/**
 * Service Status Enum
 */
export const ServiceStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  ARCHIVED: 'archived'
}

/**
 * Facility Types Enum
 */
export const FacilityTypes = {
  CLINIC: 'Clinic',
  HOSPITAL: 'Hospital',
  MOBILE_UNIT: 'Mobile Unit',
  PHARMACY: 'Pharmacy',
  DIAGNOSTIC_CENTER: 'Diagnostic Center',
  WELLNESS_CENTER: 'Wellness Center'
}

export default ServiceSchema
